<!--
Author: Alexey Usov (dax@xdax.ru, https://github.com/doubleaxe)
Please don't remove this comment if you use unmodified file
-->
<script setup lang="ts">
import {injectBlueprintModel} from '@/scripts/model/store';
import {mdiDotsVertical, mdiDelete, mdiCog, mdiHelpCircle, mdiArrangeSendToBack, mdiCounter, mdiInformationOutline, mdiFolderOutline, mdiSigma} from '@mdi/js';
import {ref} from 'vue';
import {useIsMobile} from '@/composables';

const blueprintModel = injectBlueprintModel();
//fork addition (Stage I): on mobile this menu also carries the
//actions that left the condensed phone toolbar
const {isMobile} = useIsMobile();
const showSettingsDialog = ref(false);
const showHelpDialog = ref(false);
const showAboutDialog = ref(false);
const showAutoLayoutDialog = ref(false);
const showApplyCountDialog = ref(false);
const showLoadDialog = ref(false);
</script>

<template>
    <v-menu>
        <template #activator="{ props }">
            <v-btn :icon="mdiDotsVertical" v-bind="props" />
        </template>
        <v-list>
            <v-list-item
                :prepend-icon="mdiDelete"
                title="Clear All"
                @click="blueprintModel.clear()"
            />
            <!-- fork addition (Stage I): mobile-only — Load and Solve
                 live here on the phone; on desktop they stay in the
                 toolbar and this menu is unchanged -->
            <v-list-item
                v-if="isMobile"
                :prepend-icon="mdiFolderOutline"
                title="Load Blueprint"
                @click="showLoadDialog = true"
            />
            <v-list-item
                v-if="isMobile"
                :prepend-icon="mdiSigma"
                title="Solve Graph"
                :disabled="blueprintModel.autoSolveGraph"
                @click="blueprintModel.solveGraph(true)"
            />
            <v-divider horizontal />
            <v-list-item
                :prepend-icon="mdiArrangeSendToBack"
                title="Auto Layout Graph"
                @click="showAutoLayoutDialog = true"
            />
            <v-list-item
                :prepend-icon="mdiCounter"
                title="Mass Update Counts"
                @click="showApplyCountDialog = true"
            />
            <v-divider horizontal />
            <v-list-item
                :prepend-icon="mdiCog"
                title="Settings"
                @click="showSettingsDialog = true"
            />
            <v-list-item
                :prepend-icon="mdiHelpCircle"
                title="Help"
                @click="showHelpDialog = true"
            />
            <v-list-item
                :prepend-icon="mdiInformationOutline"
                title="About"
                @click="showAboutDialog = true"
            />
        </v-list>
    </v-menu>
    <div class="d-none">
        <load-share-dialog v-model="showLoadDialog" />
        <graph-layout-dialog v-model="showAutoLayoutDialog" />
        <apply-count-dialog v-model="showApplyCountDialog" />
        <settings-dialog v-model="showSettingsDialog" />
        <help-dialog v-model="showHelpDialog" />
        <about-dialog v-model="showAboutDialog" />
    </div>
</template>
